import * as React from "react";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { PublicSite_CustomPageData } from "../../../application.mod";


export type QuoteBlockProps<extra_images> = {
  index: number
  text: string
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function QuoteBlock<customBlockData, extra_images>(
  props: QuoteBlockProps<extra_images>,
  options?: { style?: QuoteBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: _ => {
        return (
          <section className="block block--quote"
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            <div className="block__inner container--xl grid--spacing">
              <div className="block__content">
                <blockquote className="block__quote typo--2xl">
                  <div dangerouslySetInnerHTML={{__html: props.text}} />
                  <div className="block__shape" aia-hidden="true"></div>
                </blockquote>
              </div>
            </div>
          </section>
        )
      },
    })
}
